import consumer from "./consumer";

const HEARTBEAT_MS = 30000;

consumer.subscriptions.create("AppearanceChannel", {
  initialized() {
    this.heartbeat = this.heartbeat.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);

    this.heartbeatTimer = null;
  },

  connected() {
    // Start heartbeats
    this.startHeartbeat();
    document.addEventListener("visibilitychange", this.onVisibilityChange);

    // send an immediate heartbeat
    this.heartbeat();
  },

  disconnected() {
    this.stopHeartbeat();
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
  },

  rejected() {
    this.stopHeartbeat();
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
  },

  startHeartbeat() {
    this.stopHeartbeat();
    this.heartbeatTimer = setInterval(this.heartbeat, HEARTBEAT_MS);
  },

  stopHeartbeat() {
    if (this.heartbeatTimer) clearInterval(this.heartbeatTimer);
    this.heartbeatTimer = null;
  },

  heartbeat() {
    // lightweight, safe
    this.perform("heartbeat");
  },

  onVisibilityChange() {
    // Optional: when user comes back, ping immediately
    if (document.visibilityState === "visible") this.heartbeat();
  },

  received(data) {
    if (data.action === 'logout') {
      this.unsubscribe();
      window.location.href = data.redirect_url
    }
  }
});
